import { Skeleton } from '@material-ui/lab';
import type { LaunchPadData } from '@mogul/api-client';
import { LaunchPadType } from '@mogul/api-client';
import React from 'react';

import { CarouselComponent } from '../../components/carousel/Carousel.component';
import { Artists } from '../../components/launchpad/Artists.component';
import { Faq } from '../../components/launchpad/Faq.component';
import { FooterBannerComponent } from '../../components/launchpad/FooterBanner.component';
import { LaunchpadInfo } from '../../components/launchpad/LaunchpadFeaturedHeader.component';
import { LaunchpadMinting } from '../../components/launchpad/LaunchpadMinting.component';
import { PromoVideo } from '../../components/launchpad/PromoVideo.component';
import { RoadMap } from '../../components/launchpad/Roadmap.component';
import styles from './LaunchPadInner.module.css';

export interface Props {
  launchPadData: LaunchPadData | undefined;
  mintedAmount: number;
  loading: boolean;
  MetaMaskModal?: any;
  SetMintingModal?: any;
  SignupModal?: any;
  WrongNetworkModal?: any;
  history?: any;
  walletInfo?: any;
  setModal?: any;
  preview?: boolean;
}

export const LaunchPadInner: React.FC<Props> = props => {
  const {
    launchPadData,
    mintedAmount,
    loading,
    MetaMaskModal,
    SetMintingModal,
    SignupModal,
    WrongNetworkModal,
    history,
    walletInfo,
    setModal,
    preview = false,
  } = props;

  return (
    // Call container
    <div
      style={preview ? { height: '100%', overflowY: 'auto' } : {}}
      className={`${styles.launchpadContainer} w-full flex flex-col items-center`}
    >
      <div
        className={` w-full flex flex-col items-center`}
        style={preview ? { pointerEvents: 'none' } : {}}
      >
        {loading ? (
          <div
            className={`h-full flex flex-col sm:grid place-items-center w-screen sm:w-auto`}
          >
            <Skeleton variant="rect" height={'700px'} />
          </div>
        ) : (
          <>
            <div
              className={`h-full w-full flex flex-col sm:grid place-items-center`}
            >
              <div
                className="w-full items-center sm:mt-0 mt-10"
                style={preview ? { marginTop: '0px' } : {}}
              >
                <div className="w-full">
                  {launchPadData?.launchPadType === LaunchPadType.NftDrop ? (
                    <LaunchpadMinting
                      setModal={setModal}
                      walletInfo={walletInfo}
                      MetaMaskModal={MetaMaskModal}
                      SetMintingModal={SetMintingModal}
                      SignupModal={SignupModal}
                      WrongNetworkModal={WrongNetworkModal}
                      launchPadData={launchPadData}
                      startDate={
                        new Date(
                          launchPadData.saleDate ? launchPadData.saleDate : '',
                        )
                      }
                      preSaleDate={
                        new Date(
                          launchPadData.presaleDate
                            ? launchPadData.presaleDate
                            : '',
                        )
                      }
                      saleEndDate={
                        new Date(
                          launchPadData.endDate ? launchPadData.endDate : '',
                        )
                      }
                      preSales={mintedAmount}
                      history={history}
                    />
                  ) : (
                    <LaunchpadInfo
                      launchPadData={launchPadData}
                      preSales={mintedAmount}
                      history={history}
                    />
                  )}
                </div>
              </div>
              {launchPadData?.collection?.featuredVideo && (
                <div className="w-full sm:w-8/12 sm:mx-auto sm:px-1">
                  <PromoVideo
                    videoUrl={launchPadData.collection.featuredVideo}
                  />
                </div>
              )}
              {launchPadData?.nftSamples &&
                launchPadData.nftSamples.length > 0 && (
                  <div className="w-full overflow-y-auto items-center mt-28 sm:mt-10">
                    <div className="w-full">
                      <CarouselComponent items={launchPadData.nftSamples} />
                    </div>
                    <div className="py-10"></div>
                  </div>
                )}
            </div>
            {launchPadData?.roadmap && launchPadData.roadmap.length > 0 && (
              <div className="w-full sm:w-8/12 sm:mx-auto">
                <RoadMap roadmapData={launchPadData.roadmap} />
              </div>
            )}
            {launchPadData?.artists && launchPadData.artists.length > 0 && (
              <div className="w-full sm:w-8/12 sm:mx-auto my-10 sm:px-0">
                <Artists artists={launchPadData.artists} />
              </div>
            )}
            {launchPadData?.faqs && launchPadData.faqs.length > 0 && (
              <div className="w-full sm:w-8/12 sm:mx-auto my-10 sm:px-0">
                <Faq faqData={launchPadData.faqs} />
              </div>
            )}
            {launchPadData?.bottomBanner?.publicUrl && (
              <div className="w-full mt-20">
                <FooterBannerComponent
                  communityInfo={launchPadData.communityInfo ?? ''}
                  bannerImage={launchPadData.bottomBanner.publicUrl}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
